/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { Query_Keys } from "../../../lib/queryKeys";
import { mergeQueryKeys, getBaseQueryKey } from "../utils/queryKeyHelpers";
import { auditLogRefreshKeys } from "./sharedRefreshKeys";

const jobBaseKeys = mergeQueryKeys(
  getBaseQueryKey(Query_Keys.jobs),
  getBaseQueryKey(Query_Keys.associated_guest_restaurants),
  getBaseQueryKey(Query_Keys.jobs_dropdown),
  getBaseQueryKey(Query_Keys.job_description)
);

const jobImportKeys = mergeQueryKeys(
  jobBaseKeys,
  auditLogRefreshKeys
);

const jobUpdateKeys = mergeQueryKeys(
  jobBaseKeys,
  getBaseQueryKey(Query_Keys.group_members)
);

const jobDepartmentUpdateKeys = mergeQueryKeys(
  jobUpdateKeys,
  getBaseQueryKey(Query_Keys.labor_reports),
  getBaseQueryKey(Query_Keys.labor_report_summary)
);

export const jobMutationKeyGroups = {
  fetch: jobBaseKeys,
  import: jobImportKeys,
  create: jobBaseKeys,
  update: jobUpdateKeys,
  updateDepartment: jobDepartmentUpdateKeys,
  delete: jobBaseKeys,
  upload: jobBaseKeys,
};
